import { render, staticRenderFns } from "./ModelManagement.vue?vue&type=template&id=62c16ce5&scoped=true&"
import script from "./ModelManagement.vue?vue&type=script&lang=js&"
export * from "./ModelManagement.vue?vue&type=script&lang=js&"
import style0 from "./ModelManagement.vue?vue&type=style&index=0&id=62c16ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c16ce5",
  null
  
)

export default component.exports